import { instance } from 'api/api';
import { APIResponse } from 'tools/types';
import { RawIssuesContext } from 'api/element-issues';

export const domainIssuesAPI = {
    async getContext(domainId: number): Promise<RawIssuesContext> {
        const response = await instance.get<APIResponse<RawIssuesContext>>(`data/admin/domain/${domainId}/issues`);
        return response.data.data;
    },

    // Domain-scoped clarifying-question endpoints (MI-30068): mirror the dataset/element trio.
    async answerQuestion(domainId: number, questionId: string, answer: string): Promise<void> {
        await instance.post(`data/admin/domain/${domainId}/clarifying-question/${questionId}/answer`, { answer });
    },

    async skipQuestion(domainId: number, questionId: string): Promise<void> {
        await instance.post(`data/admin/domain/${domainId}/clarifying-question/${questionId}/skip`);
    },

    async undoQuestion(domainId: number, questionId: string): Promise<void> {
        await instance.post(`data/admin/domain/${domainId}/clarifying-question/${questionId}/undo`);
    },
};
